// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"b8150baa","252":"a4978e39","504":"fbc3322d","633":"2f3faaff","659":"7ac4caf4","710":"6c42604e","861":"c326e2ee"}[chunkId] + ".chunk.js";
};